import { useState, useEffect } from 'react';

export function useInstallPrompt() {
  const [isIOS] = useState(() => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
  const [isStandalone] = useState(() =>
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Check if user dismissed prompt before
    const dismissed = localStorage.getItem('pwa-install-dismissed');
    const dismissedTime = dismissed ? parseInt(dismissed, 10) : 0;
    const sevenDays = 7 * 24 * 60 * 60 * 1000;

    let timeoutId;
    // Show prompt if: iOS + not installed + not recently dismissed
    if (isIOS && !isStandalone && (Date.now() - dismissedTime > sevenDays)) {
      // Delay showing prompt for better UX
      timeoutId = setTimeout(() => setShowPrompt(true), 3000);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isIOS, isStandalone]);

  const dismissPrompt = (permanent = false) => {
    setShowPrompt(false);
    if (permanent) {
      localStorage.setItem('pwa-install-dismissed', Date.now().toString());
    }
  };

  return { isIOS, isStandalone, showPrompt, dismissPrompt };
}
